import * as React from 'react';
import { compose, pure } from 'recompose';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { createStyles, withStyles } from '@material-ui/styles';
import { transition } from '@topconagriculture/theme';
import { FontIcon } from '../FontIcon';
import cn from 'classnames';
import { Tooltip } from '../Tooltip';
import { Text } from '../Text';
const notchWidth = 12;
const styles = (theme) => createStyles({
    itemCollapsed: {},
    root: {
        transition: transition(100),
        paddingLeft: notchWidth,
        '&:hover': {
            backgroundColor: theme.color.grey.lightest,
            paddingLeft: notchWidth - 5,
        },
        '&$selected': {
            backgroundColor: 'transparent',
            paddingLeft: notchWidth * 2,
            '& span': {
                color: `${theme.components.sidebar.colors.itemSelected} !important`,
                fontWeight: theme.font.weight.bold,
            },
        },
        '&$selected&$itemCollapsed': {
            paddingLeft: notchWidth,
            '& span': {
                color: `white !important`,
                fontWeight: theme.font.weight.bold,
            },
        },
        '&:hover&$selected': {
            backgroundColor: theme.color.grey.lightest,
            color: theme.components.sidebar.colors.itemSelected,
        },
    },
    selected: {
        color: theme.color.brand.main,
        fontWeight: theme.font.weight.bold,
        backgroundColor: theme.color.grey.lightest,
    },
    selectedAndPrevented: {
        color: theme.color.brand.main,
        backgroundColor: 'transparent',
        cursor: 'default',
        fontWeight: theme.font.weight.bold,
    },
    itemFocus: {
        backgroundColor: theme.color.grey.light,
    },
    selectionNotch: {
        width: notchWidth,
        height: '100%',
        backgroundColor: theme.components.sidebar.colors.itemSelected,
        position: 'absolute',
        left: -notchWidth,
        top: 0,
        transition: transition(100),
    },
    selectionNotchVisible: {
        left: 0,
    },
    selectionNotchCollapsed: {
        width: '100%',
    },
    itemIcon: {
        minWidth: 50,
    },
    itemLabel: {
        flex: '1 1 auto',
    },
    nestedItem: {
        paddingLeft: theme.space.padding.large,
        '&:hover': {
            paddingLeft: notchWidth * 2,
        },
        '&$selected': {
            paddingLeft: notchWidth * 3,
        },
    },
    menuTooltip: {
        backgroundColor: theme.color.brand.main,
        color: theme.color.font.light,
    },
});
const getIconProps = (icon) => {
    if (typeof icon !== 'string') {
        return { iconName: icon.iconName, ...icon.iconOptions };
    }
    return { iconName: icon };
};
const AppSidebarListItem = (props) => {
    const { label, icon, onClick, isSubItem, children, classes, collapsedVersion, theme, disabled, disableTooltip, isActive, preventClickWhenActive, className: classNameProp, } = props;
    const listItemClass = cn(classNameProp, collapsedVersion && classes.itemCollapsed, !collapsedVersion && isSubItem && classes.nestedItem);
    return (React.createElement(Tooltip, { classes: { tooltip: classes.menuTooltip }, disableHoverListener: disableTooltip || !collapsedVersion, title: label, placement: "right" },
        React.createElement(ListItem, { className: listItemClass, onClick: preventClickWhenActive && isActive ? null : onClick, button: true, selected: isActive, disableRipple: isActive, classes: {
                root: classes.root,
                selected: preventClickWhenActive ? classes.selectedAndPrevented : classes.selected,
                focusVisible: classes.itemFocus,
            }, key: label, disabled: disabled },
            React.createElement("div", { className: cn(classes.selectionNotch, isActive && classes.selectionNotchVisible, isActive && collapsedVersion && classes.selectionNotchCollapsed) }),
            React.createElement(ListItemIcon, { className: classes.itemIcon },
                React.createElement(FontIcon, Object.assign({ top: 3, left: 8, size: isSubItem ? 18 : 24 }, getIconProps(icon), { color: theme.color.font.dark }))),
            React.createElement(Text, { block: true, className: classes.itemLabel }, !collapsedVersion && label),
            children)));
};
const ComposedAppSidebarListItem = compose(pure, withStyles(styles, { withTheme: true }))(AppSidebarListItem);
ComposedAppSidebarListItem.displayName = 'AppSidebarListItem';
export default ComposedAppSidebarListItem;
//# sourceMappingURL=AppSidebarListItem.js.map